import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const GooglePlayColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.92532 7.68676L2.05253 13.8396C2.11847 14.0733 2.23698 14.2889 2.399 14.4698C2.56102 14.6507 2.76225 14.7922 2.98732 14.8834C3.21239 14.9746 3.45534 15.0131 3.69758 14.9961C3.93983 14.979 4.17497 14.9068 4.38502 14.7849L10.993 11.0214L7.92532 7.68676Z"
      fill="#EA4335"
    />
    <path
      d="M13.8638 6.64086L11.0061 5.00418L7.78966 7.8268L11.0193 11.0126L13.855 9.39346C14.1062 9.26192 14.3167 9.06413 14.4635 8.82152C14.6103 8.57891 14.6879 8.30074 14.6879 8.01716C14.6879 7.73358 14.6103 7.45541 14.4635 7.2128C14.3167 6.97019 14.1062 6.7724 13.855 6.64086H13.8638Z"
      fill="#FBBC04"
    />
    <path
      d="M2.05253 2.16406C2.01703 2.29529 1.99937 2.43071 2.00002 2.56666V13.437C2.00037 13.5729 2.01802 13.7082 2.05253 13.8396L8.12663 7.8443L2.05253 2.16406Z"
      fill="#4285F4"
    />
    <path
      d="M7.96909 8.00184L11.0061 5.00418L4.4069 1.22319C4.15863 1.07778 3.87627 1.00078 3.58856 1C3.24109 0.999315 2.90292 1.11226 2.6256 1.32163C2.34828 1.531 2.14704 1.82531 2.05253 2.15968L7.96909 8.00184Z"
      fill="#34A853"
    />
  </Icon>
));

export default GooglePlayColor;
